import '@stackflow/plugin-basic-ui/index.css';
import BottomSheets from '@components/BottomSheets';
import ErrorBoundary from '@components/ErrorBoundary';
import GlobalModal from '@components/GlobalModal';
import GlobalLoader from '@components/Loading/GlobalLoader';
import Toast from '@components/Toast';
import AppCookieProvider from '@providers/AppCookieProvider';
import AppCustomProvider from '@providers/AppCustomProvider';
import AppQueryProvider from '@providers/AppQueryProvider';
import ColorProvider from '@providers/ColorProvider';
import DatadogProvider from '@providers/DatadogProvider';
import UserProvider from '@providers/UserProvider';
import { Stack } from '@router/stackflow';
import '@styles/index.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { store } from '@store/store';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Provider } from 'react-redux';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Seoul');

function App() {
  return (
      <AppCookieProvider>
          <AppQueryProvider>
              <Provider store={store}>
                  <ColorProvider>
                      <DatadogProvider>
                          <AppCustomProvider>
                              <ErrorBoundary>
                                  <UserProvider>
                                      <Stack/>
                                      <Toast/>
                                      <GlobalLoader/>
                                      <GlobalModal/>
                                      <BottomSheets/>
                                  </UserProvider>
                              </ErrorBoundary>
                          </AppCustomProvider>
                      </DatadogProvider>
                  </ColorProvider>
              </Provider>
          </AppQueryProvider>
      </AppCookieProvider>
  );
}

export default App;
